import { useParams } from "react-router-dom";
import { authClient } from "@/lib/auth-client";
import { useMe } from "@/hooks/use-me";

export function useCurrentOrg() {
  const { orgId, slug } = useParams<{ orgId: string; slug: string }>();
  const { data: orgs, isPending: orgsPending } = authClient.useListOrganizations();
  const { me, role, isOwner, isAdmin, isManager, isPending: mePending } = useMe();

  const org = orgs?.find((o) => o.id === orgId) ?? null;

  return {
    org,
    orgId,
    slug,
    me,
    role,
    isOwner,
    isAdmin,
    isManager,
    isPending: orgsPending || mePending,
  };
}
